import { exercisesAsideManager } from './ExercisesAside/zustand/exercisesAsideManager'
import { useGetExercisesAdminRouter } from './useGetExercisesRouter'

export const ExercisesListAdminController = {
	// Если требуются уроки курса, то передаётся идентификатор.
	// Если не передан, то будут загружены уроки школы
	router: useGetExercisesAdminRouter,
	openExercisesAside: exercisesAsideManager.open,
}
